import { Injectable } from '@angular/core';
import { ApiResponseModelWrapper } from '@tablesready/common-ui';
import { ApiClientService } from '@tablesready/api-client';

export interface IPartyOptions {
  party_id: string;
  seated_time?: any;
  canceled_time?: any;
  duration?: number;
  checkin_time?: number;
  completedAt?: number;
  performRefund?: boolean;
  overrideSeatedConflict?: boolean;
}

export interface MarkPartyResult extends ApiResponseModelWrapper<IPartyOptions> {
  /** True when the seat failed because the table is already in use; the user may override. */
  conflict?: boolean;
  conflictParties?: string[];
}

@Injectable({ providedIn: 'root' })
export class MarkPartyService {
  constructor(private readonly http: ApiClientService) {}

  setParty(options: IPartyOptions) {
    return this.http.post<MarkPartyResult>('/v.1/markParty', options);
  }
}
